import { startCase } from 'lodash';

import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class PageTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot) {
    const title = this.buildTitle(routerState);
    if (title !== undefined) {
      const titleTab = this.getTitleTab(routerState, routerState.root).join(' - ');
      this.title.setTitle(`Atlas : ${title} ${titleTab?.length > 0 ? '- ' + titleTab : ''}`);
    }
  }

  getTitle(routerState: RouterStateSnapshot) {
    return this.buildTitle(routerState);
  }

  private getTitleTab(state: any, parent: any): string[] {
    const title = [];
    if (parent?.data?.title) {
      title.push(startCase(parent.data.title));
    }

    if (state && parent) {
      title.push(...this.getTitleTab(state, state.firstChild(parent)));
    }

    return title;
  }
}
